import React from "react";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "reactflow";

import "./analytics.css";

function formatPct(n) {
	if (n == null || Number.isNaN(n)) return "0%";
	const rounded = Math.round(n * 10) / 10;
	return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}%`;
}

export default function AnalyticsEdge({
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	markerEnd,
	data = {},
}) {
	const [edgePath] = getSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});

	const pctSource = data.percentageFromSource ?? 0;
	const pctTotal = data.percentageFromTotal ?? 0;
	const pctAmongExits = data.percentageAmongExits ?? 0;
	const pctBasis = data.analyticsEdgePctBasis ?? "exits";
	const loaded = data.analyticsLoaded === true;

	const badgeX = sourceX + 30;
	const badgeY = sourceY;

	return (
		<>
			<BaseEdge path={edgePath} markerEnd={markerEnd} style={{ strokeWidth: 2 }} />
			<EdgeLabelRenderer>
				<div
					className="nodrag nopan analytics-edge-badge"
					style={{
						position: "absolute",
						transform: `translate(-50%, -50%) translate(${badgeX}px,${badgeY}px)`,
						pointerEvents: "all",
					}}
				>
					{loaded ? formatPct(pctSource) : "…"}
					{loaded ? (
						<div className="analytics-edge-tooltip">
							{pctBasis === "arrivals" ? (
								<>
									{formatPct(pctSource)} das conversas que chegaram a este bloco seguiram
									por aqui · {formatPct(pctTotal)} de todas as conversas criadas no período
								</>
							) : (
								<>
									{formatPct(pctSource)} dos desvios registrados saindo deste bloco foram por
									aqui · {formatPct(pctTotal)} de todas as conversas criadas no período
								</>
							)}
							{data.edgeCount != null && data.outgoingTotal != null ? (
								<>
									<br />
									<span style={{ opacity: 0.85 }}>
										{data.edgeCount}{" "}
										{data.edgeCount === 1 ? "vez" : "vezes"} por este caminho ·{" "}
										{data.outgoingTotal}{" "}
										{data.outgoingTotal === 1
											? "desvio registrado neste bloco"
											: "desvios registrados neste bloco"}
										{data.sourceNodeCount != null && data.sourceNodeCount > 0 ? (
											<>
												<br />
												{data.sourceNodeCount}{" "}
												{data.sourceNodeCount === 1
													? "conversa chegou"
													: "conversas chegaram"}{" "}
												a este bloco
											</>
										) : null}
										{pctBasis === "arrivals" &&
										data.outgoingTotal > 0 &&
										data.sourceNodeCount > 0 &&
										data.outgoingTotal < data.sourceNodeCount &&
										Math.round(pctAmongExits * 10) / 10 !==
											Math.round(pctSource * 10) / 10 ? (
											<>
												<br />
												<span style={{ opacity: 0.75 }}>
													(Entre só os desvios: {formatPct(pctAmongExits)} por aqui)
												</span>
											</>
										) : null}
									</span>
								</>
							) : null}
						</div>
					) : null}
				</div>
			</EdgeLabelRenderer>
		</>
	);
}
